<template>
    <div>
        <ScrollBar :minHeight="450" :maxHeight="450">
            <div v-for="patrimony in patrimonies" :key="patrimony.id">
                <div :class="{ 'background-danger': patrimony.status == 1 }" class="div-barcode">
                    <Molded>
                        <b-row>
                            <b-col sm="10">
                                <div class="title title-patrimony"> {{ patrimony.barCode }}</div>
                            </b-col>
                            <b-col sm="1">
                                <span v-if="patrimony.status == 1">
                                    <i class="fa-solid fa-do-not-enter icon-movement-danger"></i>
                                </span>
                                <span v-if="patrimony.status == 2">
                                    <i class="fa-solid fa-circle-check icon-movement-success"></i>
                                </span>
                            </b-col>
                            <b-col sm="1">
                                <Button :_key="'btnRemove' + patrimony.itemMovementBulkId" type="danger"
                                    classIcon="fa-solid fa-trash" size="small"
                                    :params="{ itemMovementBulkId: patrimony.itemMovementBulkId }" :clicked="remove" />
                            </b-col>
                        </b-row>
                    </Molded>
                </div>
            </div>
            <div v-show="patrimonies.length == 0">
                <span>Nenhum produto encontrado!</span>
            </div>
        </ScrollBar>
    </div>
</template>

<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";

import { mapActions, mapMutations } from "vuex";

export default {
    name: "ItemsPatrimony",
    props: ["patrimonies"],
    components: {
        Button,
        Molded,
        ScrollBar
    },
    data() {
        return {
            urlDelete: "/api/v1/operational/items-movement-bulk/delete",
            patrimoniesLocal: []
        }
    },
    methods: {
        ...mapMutations("generic", ["addEvent", "removeLoading"]),
        ...mapActions("generic", ["deleteAllApi"]),
        remove(param) {
            let params = {
                url: this.urlDelete,
                selected: [param.itemMovementBulkId],
            };
            this.deleteAllApi(params).then((response) => {
                if (response.success) {
                    var patrimonies = this.patrimonies.filter(patrimony => patrimony.itemMovementBulkId !== param.itemMovementBulkId);
                    this.addEvent({ name: "productRemoved", data: patrimonies });
                }
                this.removeLoading(['btnRemove' + param.itemMovementBulkId]);
            });
        },
    }
}

</script>
<style scoped>
.title-patrimony {
    font-size: 16px;
    padding-bottom: 5px;
}

.div-barcode {
    margin-bottom: 10px;
}

.icon-movement-success {
    margin-top: 5px;
    font-size: 18px;
    color: #1D9E1D;
}

.icon-movement-danger {
    margin-top: 5px;
    font-size: 18px;
    color: red;
}
</style>
